import { useEffect, useState } from "react";
import { ArrowUpRight, TrendingUp } from "lucide-react";
import { http } from "@/lib/api";
import { Reveal, Eyebrow } from "./Reveal";

export const TopSales = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    http.get("/bestsellers").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;
  return (
    <section id="top-ventes" data-testid="top-sales-section" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-10 sm:py-32">
      <Reveal className="mb-12 grid gap-6 md:grid-cols-12">
        <div className="md:col-span-7">
          <Eyebrow>(03) — Top ventes</Eyebrow>
          <h2 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight">
            Les <em className="italic text-[var(--terra)]">meilleures ventes</em>, en direct.
          </h2>
        </div>
        <p className="self-end text-base leading-relaxed text-[var(--muted)] md:col-span-4 md:col-start-9">
          Les classements officiels d'Amazon, mis à jour toutes les heures, avec les prix du moment : 12 univers, des produits qui se vendent en quantité.
        </p>
      </Reveal>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((b, i) => (
          <Reveal key={b.id} delay={(i % 3) * 0.08}>
            <a href={b.url} target="_blank" rel="sponsored noopener noreferrer" data-testid={`top-sales-${b.id}`}
              className="group relative block h-64 overflow-hidden rounded-[20px] bg-[var(--ink)]">
              <img src={b.image} alt={b.label} loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-80 transition-transform duration-[1.2s] group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent" />
              <span className="absolute left-5 top-5 flex items-center gap-2 rounded-full bg-[#FBF9F5]/90 px-3 py-1.5 text-[11px] font-medium text-[var(--ink)]">
                <TrendingUp className="h-3.5 w-3.5 text-[var(--terra)]" /> Top 100 Amazon
              </span>
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-5 text-[var(--bone)]">
                <h3 className="font-display text-2xl sm:text-3xl font-light">{b.label}</h3>
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-[#FBF9F5]/60 transition-[background-color,color,transform] duration-500 group-hover:rotate-45 group-hover:bg-[var(--bone)] group-hover:text-[var(--ink)]">
                  <ArrowUpRight className="h-5 w-5" />
                </span>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
